/**
 * Selectors let us factorize logic that queries the state.
 *
 * Selectors can be used in sagas or components to avoid duplicating that logic.
 *
 * Writing selectors is optional as it is not always necessary, we provide a simple example below.
 */

import { createMongoAbility } from '@casl/ability'

const isLoginLoading = (state) => {
  return state.secure.authState.loginLoading
}
const getRequires2FASetup = (state) => {
  return state.secure.authState.requires2FASetup
}
const getChallengeId = (state) => {
  return state.secure.authState.challengeId
}
const getOtpauthUrl = (state) => {
  return state.secure.authState.otpauthUrl
}
const getManualKey = (state) => {
  return state.secure.authState.manualKey
}
const getRequires2FA = (state) => {
  return state.secure.authState.requires2FA
}
const getLoginToken = (state) => {
  return state.secure.authState.loginToken
}
const getSetUp2FaComplete = (state) => {
  return state.secure.authState.setUp2FaComplete
}
const getUser = (state) => {
  return state.secure.authState.user
}

const getToken = (state) => {
  return state.secure.authState.token
}

const isLoggedIn = (state) => {
  return state.secure.authState.token && state.secure.authState.user
}

const getRefreshToken = (state) => {
  return state.secure.authState.refreshToken
}

const getEditingAdminRole = (state) => {
  const adminRules = state.secure.authState.editingAdminRole
  const ability = createMongoAbility(adminRules ?? [])

  return ability?.can && typeof ability.can === 'function'
    ? ability
    : createMongoAbility([])
}
const getChangingPasswordRequestState = (state) => {
  return state.secure.authState.ChangingPasswordRequestState
}
const getChangingUserNameRequestState = (state) => {
  return state.secure.authState.ChangingUserNameRequestState
}
const getAdminDetailsRequestState = (state) => {
  return state.secure.authState.fetchAdminDetailsRequestState
}
const getAdminActionList = (state) => {
  return state.secure.authState.adminActions
}

const getAdminActionsFilters = (state) => {
  return state.secure.authState.adminActionsFilters
}

const getfetchAdminActionsRequestState = (state) => {
  return state.secure.authState.fetchAdminActionsRequestState
}
const getAdminActionsListOffset = (state) => {
  return state.secure.authState.adminActionPaginationOffset
}
const getResetPasswordVerificationRequestState = (state) => {
  return state.secure.authState.resetPasswordVerificationRequestState
}

const getResetPasswordEmailID = (state) => {
  return state.secure.authState.resetPasswordEmailID
}
const getResetPasswordRequestState = (state) => {
  return state.secure.authState.resetPasswordRequestState
}
const getFetchEditingAdminRoleRequestState = (state) => {
  return state.secure.authState.fetchEditingAdminRoleRequestState
}

const AuthSelectors = {
  getUser,
  isLoginLoading,
  getRequires2FASetup,
  getRequires2FA,
  getManualKey,
  getOtpauthUrl,
  getChallengeId,
  getLoginToken,
  getSetUp2FaComplete,
  getToken,
  getRefreshToken,
  isLoggedIn,
  getEditingAdminRole,
  getChangingPasswordRequestState,
  getAdminDetailsRequestState,
  getChangingUserNameRequestState,
  getAdminActionList,
  getAdminActionsFilters,
  getfetchAdminActionsRequestState,
  getAdminActionsListOffset,
  getResetPasswordVerificationRequestState,
  getResetPasswordEmailID,
  getResetPasswordRequestState,
  getFetchEditingAdminRoleRequestState,
}

export default AuthSelectors
